export default "__VITE_ASSET__CWIt6rHx__"